import apiClient from '@/services/axios'

export async function get(lessonId) {
  var response = await apiClient.get('/lessons/' + lessonId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get Lesson.')
}
